import React, { useState } from 'react';
import { IconButton, TableCell, TableRow } from '@mui/material';
import DeleteIcon from '@mui/icons-material/DeleteOutlineOutlined';
import { useDispatch } from 'react-redux';

import { removeApiKey } from '../../../actions/user';

const formatDate = (dateString) => {
  return new Date(dateString).toLocaleDateString(undefined, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  });
};

const calculateDaysSince = (dateString) => {
  const date = new Date(dateString);
  const now = new Date();
  const diffTime = Math.abs(now - date);
  return Math.round(diffTime / (1000 * 60 * 60 * 24));
};

export default function ApiKey({ api_key }) {
  const dispatch = useDispatch();
  const [removing, setRemoving] = useState(false);
  const { id, created, last_rotated } = api_key;

  const handleDelete = async (e) => {
    e.preventDefault();
    setRemoving(true);
    await dispatch(removeApiKey(id));
  };

  return (
    <TableRow>
      <TableCell>{id}</TableCell>
      <TableCell align='center'>{formatDate(created)}</TableCell>
      <TableCell align='center'>
        {calculateDaysSince(last_rotated)} Days
      </TableCell>
      <TableCell align='right'>
        <IconButton
          variant='contained'
          color='black'
          onClick={handleDelete}
          loading={removing}
        >
          <DeleteIcon />
        </IconButton>
      </TableCell>
    </TableRow>
  );
}
